export enum PropertyRegimeEnum {
    Indefinido = "Indefinido",
    ComunhaoParcial = "ComunhaoParcial",
    ComunhaoTotal = "ComunhaoTotal",
    SeparacaoTotal = "SeparacaoTotal"
}



// WEBPACK FOOTER //
// ./src/services/interfaces/trade/tradeOwner/PropertyRegimeEnum.ts